<template>
  <div class="border-wrapper">
    <slot />
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
.border-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-050, 4px);
  align-items: center;
  justify-content: center;

  padding: var(--spacing-125) var(--spacing-150);

  font: var(--mobile-text-content-regular);
  color: var(--text-primary);

  backdrop-filter: blur(10px);
  border: var(--border-width-medium) solid var(--border-secondary);
  border-radius: var(--border-radius-100);
}
</style>
